@for (tag of prettierTags; track JSON.stringify(tag)) {
  <div class="tag-container" data-testing-id="tag-badge">
    <div class="wm-tag" [ngClass]="{'small': size === 'small'}">
      <div class="name" [ngClass]="{'with-value': !!tag[1] && tag[1] !== true}" data-testing-id="tag-badge-name">{{tag[0]}}</div>
      @if (!!tag[1] && tag[1] !== true) {
        <div class="value" data-testing-id="tag-badge-value">{{tag[1]}}</div>
      }
      @if (!onlyread) {
        <div class="delete-area" (click)="deleteTag(tag); $event.stopPropagation();" data-testing-id="delete-tag">
          <fa-icon icon="times"></fa-icon>
        </div>
      }
    </div>
  </div>
}
<div class="tag-container" [ngClass]="{'small': size === 'small'}">
  <!-- We need to set tagInput.autofocus here. Doing it in tagPanel.(onShow) or directly in tagInput.[autofocus] won't work. -->
  @if (!onlyread && !(prettierTags.length === 0)) {
    <img pTooltip="New tag" tooltipPosition="top" (click)="tagPanel.show($event); tagInput.autofocus = true; tagInput.disabled = false; $event.stopPropagation();" src="assets/img/add_tag.svg" class="newtag" data-testing-id="add-new-tag-btn">
  }
  @if (!onlyread &&  prettierTags.length === 0) {
    <img pTooltip="New tag" tooltipPosition="top" (click)="tagPanel.show($event); tagInput.autofocus = true; tagInput.disabled = false; $event.stopPropagation();" src="assets/img/add_first_tag.svg" class="first-tag" data-testing-id="add-new-tag-btn">
  }
</div>
<p-popover styleClass="tag-overlay" #tagPanel (onShow)="showTagOverlay()" (onHide)="hideTagOverlay()">
  <div class="tag-input-panel">
    <!--    Disabling the input on submit is a hack to prevent an Angular Lifecycle Error that happens when trying to hide the overlaypanel from the keydown callback -->
    <input #tagInput pInputText [(ngModel)]="newTagInput" (keydown.enter)="onEnterKeydown()" [disabled]="tagInputDisabled" [pattern]="this.newTagPattern" placeholder="tag OR key=value" data-testing-id="tag-name-input"/>

    @if (newTagInput && newTagInput.length > 0) {
      <div class="confirmation-area">
        @if (!newTagInsertionInProgress) {
          <button pButton class="p-button-rounded p-button-text" pTooltip="Save changes" [disabled]="!validateTag()" tooltipPosition="top" icon="true" (click)="addTag(); $event.stopPropagation();" data-testing-id="confirm-new-tag-btn">
            <fa-icon icon="save"></fa-icon>
          </button>
        }
        @if (newTagInsertionInProgress) {
          <button pButton class="p-button-rounded p-button-text" icon="true" data-testing-id="confirm-new-tag-btn">
            <fa-icon icon="cog" animation="spin"></fa-icon>
          </button>
        }
        <button pButton class="p-button-rounded p-button-text" (click)="tagPanel.hide(); $event.stopPropagation();" pTooltip="Cancel" tooltipPosition="top" icon="true" data-testing-id="cancel-new-tag-btn">
          <fa-icon icon="times"></fa-icon>
        </button>
      </div>
    }
  </div>
</p-popover>
